<template>
    <div class="pt-2">
        <v-row no-gutters>
            <v-col cols="6" class="pl-1">
                <v-card
                    style="height: calc(100vh - 82px); overflow-y: auto"
                    class="default_card_wm elevation-0 rounded-l-0"
                >
                    <v-row no-gutters>
                        <v-col cols="6" class="d-flex align-left text-left">
                            <v-btn-back
                                @click.stop="back()"
                                v-if="mode !== 'GeneralLedger' && goBackHistory"
                                data-cy="document-back"
                            />
                            <template v-if="!isPDF && zoomManager && windowStep === 'display-pdf'">
                                <v-btn-icon
                                    icon="$oss-zoom-out"
                                    :disabled="zoomManager.disableZoomOut()"
                                    @click.stop="zoomManager.zoomOut()"
                                />
                                <v-btn-icon
                                    icon="$oss-focus"
                                    :disabled="zoomManager.disableResetZoom()"
                                    @click.stop="zoomManager.resetZoom()"
                                />
                                <v-btn-icon
                                    icon="$oss-zoom-in"
                                    :disabled="zoomManager.disableZoomIn()"
                                    @click.stop="zoomManager.zoomIn()"
                                />
                                <v-btn-icon
                                    class="my-0 mr-1"
                                    @click.stop="
                                        documentPdfRotation = rotate(
                                            'left',
                                            zoomManager,
                                            documentPdfRotation,
                                        )
                                    "
                                    icon="$fa-undo"
                                >
                                </v-btn-icon>
                                <v-btn-icon
                                    class="my-0"
                                    @click.stop="
                                        documentPdfRotation = rotate(
                                            'right',
                                            zoomManager,
                                            documentPdfRotation,
                                        )
                                    "
                                    icon="$fa-redo"
                                >
                                </v-btn-icon>
                                <v-btn-icon
                                    icon="$oss-eye"
                                    :disabled="zoomManager.disableResetZoom()"
                                    class="ml-1"
                                    :loading="ocrLoading"
                                    @click.stop="onOCRChanged()"
                                    v-if="document.signedUrlOCR"
                                />
                                <v-text-field-filled
                                    v-model="selectedText"
                                    v-show="selectedText"
                                    id="selectedText"
                                    hide-details
                                    class="ml-2 small-prepend-icon"
                                    append-inner-icon="$oss-close"
                                    @click:append-inner="emptySelectedText"
                                />
                            </template>
                            <template v-if="isPDF && windowStep === 'display-pdf'">
                                <v-btn-icon icon="$oss-zoom-out" @click.stop="zoomOutPdf" />
                                <v-btn-icon icon="$oss-focus" @click.stop="resetZoomPdf()" />
                                <v-btn-icon icon="$oss-zoom-in" @click.stop="zoomInPdf" />
                                <v-btn-icon
                                    class="my-0 mr-1"
                                    @click.stop="
                                        documentPdfRotation = rotate(
                                            'left',
                                            zoomManager,
                                            documentPdfRotation,
                                        )
                                    "
                                    icon="$fa-undo"
                                >
                                </v-btn-icon>
                                <v-btn-icon
                                    class="my-0"
                                    @click.stop="
                                        documentPdfRotation = rotate(
                                            'right',
                                            zoomManager,
                                            documentPdfRotation,
                                        )
                                    "
                                    icon="$fa-redo"
                                >
                                </v-btn-icon>
                            </template>
                        </v-col>
                        <v-col cols="6" class="pr-3 d-flex align-center justify-end">
                            <v-tooltip
                                :text="editMode ? $t('emprunts.discard') : $t('emprunts.edit')"
                            >
                                <template v-slot:activator="{ props }">
                                    <v-icon
                                        class="mt-1 mx-2 d-flex flex-end rounded-circle bg-primary edit-emprunt"
                                        v-if="editedLoan.length > 0"
                                        size="small"
                                        id="editEmprunts"
                                        @click="toggleEditMode"
                                        w
                                        v-bind="props"
                                    >
                                        {{ editMode ? "$fa-redo" : "$oss-edit" }}
                                    </v-icon>
                                </template>
                            </v-tooltip>
                            <v-btn-toggle
                                v-model="windowStep"
                                rounded="xl"
                                class="mt-1"
                                density="compact"
                                divided
                                variant="outlined"
                                color="secondary"
                                mandatory
                            >
                                <v-btn :value="'table'" icon="$fa-table"> </v-btn>
                                <v-btn :value="'display-accounting-lines'" icon="$fa-list"></v-btn>
                                <v-btn
                                    :value="'display-pdf'"
                                    icon="$oss-file"
                                    :disabled="!document.signedUrl"
                                    :readonly="!document.signedUrl"
                                >
                                </v-btn>
                            </v-btn-toggle>
                            <v-menu offset-y class="pl-2">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon icon="$dots_vertical" v-bind="props" />
                                </template>
                                <v-list nav rounded="xl">
                                    <v-list-item
                                        v-model="windowStep"
                                        v-if="isAccountingUser"
                                        @click="windowStep = 'display-activity'"
                                        :disabled="!document.id"
                                    >
                                        <v-list-item-title>
                                            {{ $t("emprunts.afficher-activite") }}
                                        </v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-activity</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-divider class="mb-2" />
                                    <v-list-item
                                        @click="startDownloadFile"
                                        v-if="document.signedUrl"
                                    >
                                        <v-list-item-title>{{
                                            $t("emprunts.telecharger-doc")
                                        }}</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-download</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="uploadDocumentDialog = true"
                                        :disabled="!document.id"
                                    >
                                        <v-list-item-title>{{
                                            $t("emprunts.ajouter-document")
                                        }}</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-upload</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="analyseDocumentDialog = true"
                                        v-if="restartAnalysis"
                                    >
                                        <v-list-item-title>Relancer l'analyse</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-scan</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-divider class="mb-2" />
                                    <v-list-item
                                        @click="deleteDocumentDialog = true"
                                        :disabled="disabledDelete"
                                        color="error"
                                        :active="!disabledDelete"
                                    >
                                        <v-list-item-title>{{
                                            $t("emprunts.supprimer")
                                        }}</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon color="primary" size="small">$oss-trash</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-window v-model="windowStep">
                                <v-window-item :value="'table'">
                                    <v-data-table
                                        :headers="headers"
                                        :items="editedLoan"
                                        class="table"
                                        fixed-header
                                        height="90vh"
                                        :items-per-page="-1"
                                        v-if="!$vuetify.display.mobile"
                                        density="compact"
                                    >
                                        <template v-slot:item="props">
                                            <tr :class="props.item.selected ? 'info' : ''">
                                                <td class="text-left">{{ props.item.month }}</td>
                                                <td class="text-left">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.dueAmountStartPeriod,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.monthlyPayment,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left">
                                                    <v-text-field
                                                        v-model="
                                                            props.item.formattedValues.amortisation
                                                        "
                                                        :aria-label="$t('emprunts.amortissement')"
                                                        :class="{
                                                            'editable-field': editMode,
                                                            modified:
                                                                props.item.modifiedFields.includes(
                                                                    'amortisation',
                                                                ),
                                                            'hide-input': !editMode,
                                                        }"
                                                        density="compact"
                                                        type="text"
                                                        hide-details
                                                        @input="
                                                            handleInput(
                                                                props.item,
                                                                'amortisation',
                                                                $event,
                                                            )
                                                        "
                                                        @blur="
                                                            onBlurAction(props.item, 'amortisation')
                                                        "
                                                    ></v-text-field>
                                                </td>
                                                <!-- Editable Fields with Formatting -->
                                                <td class="text-left">
                                                    <v-text-field
                                                        :aria-label="
                                                            $t('emprunts.monthly-interest')
                                                        "
                                                        v-model="
                                                            props.item.formattedValues
                                                                .monthlyInterest
                                                        "
                                                        :class="{
                                                            'editable-field': editMode,
                                                            modified:
                                                                props.item.modifiedFields.includes(
                                                                    'monthlyInterest',
                                                                ),
                                                            'hide-input': !editMode,
                                                        }"
                                                        density="compact"
                                                        type="text"
                                                        hide-details
                                                        @input="
                                                            handleInput(
                                                                props.item,
                                                                'monthlyInterest',
                                                                $event,
                                                            )
                                                        "
                                                        @blur="
                                                            onBlurAction(
                                                                props.item,
                                                                'monthlyInterest',
                                                            )
                                                        "
                                                    ></v-text-field>
                                                </td>
                                                <td class="text-left">
                                                    <v-text-field
                                                        :aria-label="
                                                            $t('emprunts.monthly-insurance')
                                                        "
                                                        v-model="
                                                            props.item.formattedValues
                                                                .monthlyInsurance
                                                        "
                                                        :class="{
                                                            'editable-field': editMode,
                                                            modified:
                                                                props.item.modifiedFields.includes(
                                                                    'monthlyInsurance',
                                                                ),
                                                            'hide-input': !editMode,
                                                        }"
                                                        density="compact"
                                                        type="text"
                                                        hide-details
                                                        @input="
                                                            handleInput(
                                                                props.item,
                                                                'monthlyInsurance',
                                                                $event,
                                                            )
                                                        "
                                                        @blur="
                                                            onBlurAction(
                                                                props.item,
                                                                'monthlyInsurance',
                                                            )
                                                        "
                                                    ></v-text-field>
                                                </td>

                                                <td class="text-left">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.dueAmountEndPeriod,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.iraRedemptionAmount,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-slot:body.append>
                                            <tr class="totals-row">
                                                <td class="text-left font-weight-bold">Total</td>
                                                <td class="text-left"></td>

                                                <td class="text-left font-weight-bold">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            loanTotals().totalMonthlyPayments,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left font-weight-bold">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            loanTotals().totalAmortisation,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left font-weight-bold">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            loanTotals().totalInterest,
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-left font-weight-bold">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            loanTotals().totalInsurance,
                                                        )
                                                    }}
                                                </td>

                                                <td class="text-left"></td>
                                                <!-- Empty cell -->
                                                <td class="text-left"></td>
                                                <!-- Empty cell -->
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-window-item>
                                <v-window-item :value="'display-accounting-lines'">
                                    <v-row no-gutters>
                                        <v-col
                                            v-if="document && document.id"
                                            cols="12"
                                            style="height: calc(100vh - 130px); overflow-y: auto"
                                        >
                                            <accounting-item-static
                                                :companyId="selectedCompany?.id"
                                                :documentId="document?.id"
                                                :mode="isAccountingItem ? 'AllOption' : 'Embedded'"
                                                ref="accountingItemStatic"
                                                :key="accountingLinesRefreshKey"
                                                @upsert="onAccountingItemUpdated"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item :value="'display-activity'">
                                    <v-row no-gutters>
                                        <v-col
                                            v-if="document && document.id"
                                            cols="12"
                                            style="height: calc(100vh - 130px); overflow-y: auto"
                                        >
                                            <UsersActivitiesHistory :documentId="document?.id">
                                            </UsersActivitiesHistory>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item :value="'display-pdf'">
                                    <v-row no-gutters>
                                        <v-col
                                            cols="12"
                                            style="height: calc(100vh - 130px); overflow-y: auto"
                                            v-if="document && document.id && isPDF"
                                        >
                                            <ossPdf ref="ossPdfRef" :documentId="document?.id" />
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            style="height: calc(100vh - 130px); overflow-y: auto"
                                            v-else
                                        >
                                            <div
                                                style="
                                                    position: relative;
                                                    width: 100%;
                                                    height: 0;
                                                    padding: 0;
                                                    padding-bottom: 141.4516129032258%;
                                                    margin-bottom: 50px;
                                                "
                                            >
                                                <svg
                                                    id="svg-document-loan"
                                                    v-if="document"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="100%"
                                                    :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                                    style="
                                                        position: absolute;
                                                        width: 100%;
                                                        left: 0;
                                                        top: 0;
                                                        background: #fff;
                                                    "
                                                >
                                                    <g>
                                                        <image
                                                            id="svg-image-document-loan"
                                                            :xlink:href="document.signedUrl"
                                                            x="0"
                                                            y="0"
                                                            :height="`${imageHeight}px`"
                                                            :width="`${imageWidth}px`"
                                                        />
                                                        <template v-if="!showOCR">
                                                            <template
                                                                v-for="deadline in deadlines"
                                                                :key="`coord-${document.id}-${deadline.index}`"
                                                            >
                                                                <polygon
                                                                    :ref="`svg-loan-${deadline.index}`"
                                                                    :id="`svg-loan-${deadline.index}`"
                                                                    :points="
                                                                        getTokenPoints(deadline)
                                                                    "
                                                                    :style="
                                                                        deadline === toEditDeadline
                                                                            ? 'fill:rgba(0,250,0,0.5);stroke:#F9B12A;stroke-width:1'
                                                                            : 'fill:rgba(0,250,0,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                                    "
                                                                    @click.stop="
                                                                        toEditDeadline = deadline
                                                                    "
                                                                    @mouseover="
                                                                        deadline.highlightBT(
                                                                            true,
                                                                            'identified',
                                                                        )
                                                                    "
                                                                    @mouseout="
                                                                        deadline.highlightBT(false)
                                                                    "
                                                                    :class="
                                                                        deadline.focus
                                                                            ? 'highlighted'
                                                                            : !deadline.errorCount
                                                                              ? ''
                                                                              : 'error'
                                                                    "
                                                                />
                                                            </template>
                                                        </template>
                                                        <template
                                                            v-if="
                                                                showOCR &&
                                                                ocr &&
                                                                ocr.sentences &&
                                                                ocr.sentences.length
                                                            "
                                                        >
                                                            <template
                                                                v-for="(
                                                                    sentence, sIndex
                                                                ) in ocr.sentences"
                                                            >
                                                                <template
                                                                    v-for="(
                                                                        token, tIndex
                                                                    ) in sentence.tokens"
                                                                    :key="`sentence-${sIndex}-token-${tIndex}`"
                                                                >
                                                                    <polygon
                                                                        :ref="`sentence-${sIndex}-token-${tIndex}`"
                                                                        :points="
                                                                            getTokenPoints(token)
                                                                        "
                                                                        :style="
                                                                            getTokenStyle(token)
                                                                        "
                                                                        @mouseover="
                                                                            token.high = true
                                                                        "
                                                                        @mouseout="
                                                                            token.high = false
                                                                        "
                                                                        @click.stop="
                                                                            onClickToken(token)
                                                                        "
                                                                    />
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </g>
                                                </svg>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                            </v-window>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="6" class="my-0 pl-1">
                <v-card
                    style="
                        border-top-right-radius: 0px !important;
                        border-bottom-right-radius: 0px !important;
                        height: calc(100vh - 82px);
                        overflow-y: auto;
                    "
                    class="default_card_wm elevation-0 rounded-l-0"
                >
                    <v-card-text class="pt-0">
                        <v-row no-gutters>
                            <v-col cols="9" />
                            <v-col cols="3" class="mt-2 d-flex align-right justify-end">
                                <v-tooltip bottom v-if="isInsideAccountingClosing">
                                    <template #activator="{ props }">
                                        <div v-bind="props">
                                            <v-btn-edit
                                                v-if="document && document.id"
                                                :disabled="true"
                                                @click.stop="valid()"
                                                size="small"
                                            />
                                            <v-btn-add
                                                v-else
                                                :disabled="true"
                                                @click.stop="valid()"
                                                size="small"
                                            />
                                        </div>
                                    </template>
                                    <span>{{ $t("emprunts.impossible") }} </span>
                                </v-tooltip>

                                <template v-else>
                                    <v-btn-edit
                                        v-if="document && document.id"
                                        :disabled="!isValid"
                                        @click.stop="valid()"
                                        size="small"
                                    />
                                    <v-btn-add
                                        v-else
                                        :disabled="!isValid"
                                        @click.stop="valid()"
                                        size="small"
                                    />
                                </template>
                            </v-col>
                            <v-col cols="12" class="mt-2">
                                <v-list class="pt-0" density="compact">
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Nom</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div>{{ loan.title }}</div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Statut</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div
                                                        v-if="
                                                            document.errorMessage &&
                                                            reUploadDocument
                                                        "
                                                        style="color: red"
                                                    >
                                                        {{ $t("emprunts.erreur") }} :
                                                        {{ document.errorMessage }}
                                                    </div>
                                                    <div
                                                        v-else-if="
                                                            document && document.errorMessage
                                                        "
                                                        style="color: red"
                                                    >
                                                        {{ $t("emprunts.erreur-lecture") }}
                                                    </div>
                                                    <div
                                                        v-else-if="
                                                            document.status === 'ORIGINAL_UPLOADED'
                                                        "
                                                    >
                                                        En attente d'analyse
                                                    </div>
                                                    <div v-else-if="document.status === 'UPLOADED'">
                                                        En attente d'analyse
                                                    </div>
                                                    <div
                                                        v-else-if="
                                                            !document.id &&
                                                            loan.status === 'ANALYSED'
                                                        "
                                                    >
                                                        {{ $t("emprunts.en-cours-de-creation") }}
                                                    </div>
                                                    <div
                                                        v-else-if="document.status === 'VALIDATED'"
                                                    >
                                                        Créé
                                                    </div>
                                                    <div v-else>OK</div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item :ripple="false" class="oss-list-item my-2">
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters class="align-center">
                                                <v-col
                                                    cols="3"
                                                    style="
                                                        border-right: 1px #ededed solid;
                                                        height: 28px;
                                                    "
                                                    class="d-flex align-center"
                                                >
                                                    <b>Type</b>
                                                </v-col>
                                                <v-col cols="9" class="pl-2">
                                                    {{ formatCategory(loan.type) }}
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <v-col v-if="activateTagguing">
                                <FreeTag
                                    :companyTags="allCompanyTags"
                                    :document="inDocument"
                                    :splitUserPartitions="true"
                                    @changed="startToBeDoneIfNecessary"
                                    @onTagsChanged="upsertDocumentTags"
                                />
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <v-col class="d-flex align-center col-auto pr-3 title">
                                {{ $t("emprunts.informations-emprunt") }}
                            </v-col>
                            <v-col class="d-flex align-center">
                                <v-divider />
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <v-col cols="12">
                                <v-form v-model="formValid">
                                    <v-row no-gutters class="mt-2">
                                        <v-col cols="8">
                                            <v-text-field-filled
                                                v-model="loan.title"
                                                label="Libellé"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pl-2">
                                            <v-select-filled
                                                v-model="loan.amortisationType"
                                                :items="amortisationTypes"
                                                label="&#xc9;chéance"
                                                item-value="value"
                                                hide-details
                                                @update:model-value="calculateMonthlyLoanRate()"
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                density="compact"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col cols="9">
                                            <v-text-field-filled
                                                @update:model-value="
                                                    (value) => (loan.invoiceNumber = String(value))
                                                "
                                                v-model="loan.invoiceNumber"
                                                label="Numéro de contrat"
                                                density="compact"
                                                type="text"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-select-filled
                                                v-model="loan.periodicity"
                                                :label="$t('emprunts.periodicite')"
                                                :items="periodicities"
                                            ></v-select-filled>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col class="pl-3" cols="6">
                                            <v-tooltip location="bottom">
                                                <template #activator="{ props }">
                                                    <oss-date-picker-filled
                                                        v-bind="props"
                                                        v-model="loan.signatureDate"
                                                        :label="`Date de signature de l'emprunt`"
                                                        :textFieldReadOnly="false"
                                                        hide-details
                                                    />
                                                </template>
                                                <span>Date à laquelle l'emprunt a été signé.</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col class="pl-1" cols="6">
                                            <v-tooltip location="bottom">
                                                <template #activator="{ props }">
                                                    <oss-date-picker-filled
                                                        v-bind="props"
                                                        v-model="loan.startDate"
                                                        :label="`Date de début de l'emprunt`"
                                                        :textFieldReadOnly="false"
                                                        :rules="[
                                                            (v) =>
                                                                !!v || $t('settings.itemRequired'),
                                                        ]"
                                                        hide-details
                                                    />
                                                </template>
                                                <span
                                                    >Date à laquelle l'emprunt débute
                                                    officiellement. Toutes les échéances sont
                                                    calculées à partir de cette date.</span
                                                >
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col class="pl-3" cols="6">
                                            <v-tooltip location="bottom">
                                                <template #activator="{ props }">
                                                    <oss-date-picker-filled
                                                        v-bind="props"
                                                        v-model="loan.bobbeeStartDate"
                                                        :label="'Date de reprise dans bobbee'"
                                                        :textFieldReadOnly="false"
                                                        :rules="[
                                                            (v) =>
                                                                !!v || $t('settings.itemRequired'),
                                                        ]"
                                                        hide-details
                                                    />
                                                </template>
                                                <span
                                                    >Date de début de prise en compte sur bobbee.
                                                    Les échéances entre cette date et la date de
                                                    début ne sont pas comptabilisées dans bobbee,
                                                    mais restent incluses dans le calcul.</span
                                                >
                                            </v-tooltip>
                                        </v-col>
                                        <v-col class="pl-1" cols="6">
                                            <oss-text-field-filled
                                                label="Nombre d'échéances"
                                                density="compact"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                v-model="loan.loanPeriod"
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col cols="4">
                                            <oss-text-field-filled
                                                v-model="loan.netAmount"
                                                label="Montant de l'emprunt"
                                                density="compact"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                @update:modelValue="
                                                    onInputChanged($event, 'netAmount')
                                                "
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col cols="4">
                                            <oss-text-field-filled
                                                label="Taux d'emprunt ( % )"
                                                density="compact"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                v-model="loan.loanRate"
                                                @update:modelValue="
                                                    onInputChanged($event, 'loanRate')
                                                "
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <oss-text-field-filled
                                                :label="$t('emprunts.taux-emprunt')"
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                v-model="loan.monthlyLoanRate"
                                                @update:modelValue="
                                                    onInputChanged($event, 'monthlyLoanRate')
                                                "
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col cols="6">
                                            <v-select-filled
                                                v-model="loan.insuranceType"
                                                :items="insuranceTypes"
                                                label="Type d'assurance"
                                                item-value="value"
                                                hide-details
                                                density="compact"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                        <v-col cols="6" class="pl-1">
                                            <oss-text-field-filled
                                                v-if="loan.insuranceType === 'PERCENTAGE'"
                                                label="Taux d'assurance ( % )"
                                                density="compact"
                                                hide-details
                                                v-model="loan.insuranceRate"
                                                @update:modelValue="
                                                    onInputChanged($event, 'insuranceRate')
                                                "
                                            >
                                            </oss-text-field-filled>
                                            <oss-text-field-filled
                                                v-else
                                                label="Montant d'assurance"
                                                density="compact"
                                                hide-details
                                                v-model="loan.insuranceAmount"
                                                @update:modelValue="
                                                    onInputChanged($event, 'insuranceAmount')
                                                "
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col cols="4">
                                            <v-select-filled
                                                v-model="loan.organisationType"
                                                :items="organisationTypes"
                                                label="Organisme de prêt"
                                                item-value="value"
                                                return-object
                                                hide-details
                                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                                density="compact"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="8"
                                            v-if="
                                                loan.organisationType &&
                                                loan.organisationType.value === 'BANK'
                                            "
                                        >
                                            <v-text-field-filled
                                                v-model="loan.bankAccount.name"
                                                label="Banque"
                                                density="compact"
                                                hide-details
                                                readonly
                                                @click="bankDialog = true"
                                            />
                                            <!-- :rules="[v => !!v || $t('settings.itemRequired')]" -->
                                        </v-col>
                                        <v-col cols="8" v-else>
                                            <v-text-field-filled
                                                label="Fournisseur"
                                                hide-details
                                                readonly
                                                @click="thirdPartyCompanyDialog = true"
                                                :model-value="loan.thirdPartyCompany.name"
                                                density="compact"
                                            />
                                            <!-- :rules="[v => !!v || $t('settings.itemRequired')]" -->
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-row class="mt-2">
                                    <v-col cols="6">
                                        <AccountableAccount
                                            v-show="true"
                                            :showLabel="true"
                                            :label="`Compte d'intérêts`"
                                            :showValidation="false"
                                            :companyId="companyId"
                                            :showDescription="true"
                                            :inAccountableAccountType="'Selected'"
                                            :inAccountableAccountNames="['661100']"
                                            :inAccountableAccount="accountableAccountInterest"
                                            :disabled="false"
                                            @select-accountableAccount="
                                                selectAccountableAccountInterest
                                            "
                                            :defineThirdParty="false"
                                            dense
                                        >
                                        </AccountableAccount>
                                    </v-col>
                                    <v-col cols="6">
                                        <AccountableAccount
                                            v-show="true"
                                            :showLabel="true"
                                            :label="`Compte d'assurances`"
                                            :showValidation="false"
                                            :companyId="companyId"
                                            :showDescription="true"
                                            :inAccountableAccountType="'Selected'"
                                            :inAccountableAccountNames="['616']"
                                            :inAccountableAccount="accountableAccountInsurance"
                                            :disabled="false"
                                            @select-accountableAccount="
                                                selectAccountableAccountInsurance
                                            "
                                            :defineThirdParty="false"
                                            dense
                                        >
                                        </AccountableAccount>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <!-- <v-row no-gutters class="mt-2" v-if="analysis">
                            <v-col class="d-flex align-center col-auto pr-3 title">
                                Tableau d'ammortissement
                            </v-col>
                            <v-col class="d-flex align-center">
                                <v-divider />
                            </v-col>
                        </v-row> -->
                        <v-row no-gutters class="mt-2" v-if="analysis">
                            <v-col cols="12">
                                <DocumentLoanOCR
                                    :document="document"
                                    :analysis="analysis"
                                    :deadlines="deadlines"
                                ></DocumentLoanOCR>
                            </v-col>
                        </v-row>
                        <v-row class="mt-2" v-if="localEnv === 'dev'">
                            <v-col class="d-flex align-center col-auto pr-3 title">
                                Informations de renégociation
                            </v-col>
                            <v-col class="d-flex align-center">
                                <v-divider />
                            </v-col>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="4" class="mt-2 pt-0">
                                        <v-switch
                                            v-model="loan.loanEarlyRedemptionNegociation"
                                            label="Renégociation"
                                            hide-details
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-select-filled
                                            v-model="loan.negociationType"
                                            v-if="loan.loanEarlyRedemptionNegociation"
                                            :items="negociationTypes"
                                            label="Type renégociation"
                                            item-value="value"
                                            hide-details
                                            density="compact"
                                            :item-title="(item) => item.text"
                                        />
                                    </v-col>
                                    <v-col cols="4" class="pl-1">
                                        <v-select-filled
                                            v-model="loan.negociationDate"
                                            v-if="loan.loanEarlyRedemptionNegociation"
                                            :items="negociationDates"
                                            label="Date de renégociation"
                                            item-value="value"
                                            hide-details
                                            density="compact"
                                            :item-title="(item) => item.text"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4" class="pl-1">
                                        <oss-text-field-filled
                                            v-model="loan.negociationRate"
                                            v-if="
                                                loan.loanEarlyRedemptionNegociation &&
                                                loan.negociationType &&
                                                loan.negociationType === 'RATE'
                                            "
                                            label="Taux renégocié"
                                            density="compact"
                                            hide-details
                                            @update:modelValue="
                                                onInputChanged($event, 'negociationRate')
                                            "
                                        />
                                        <v-text-field-filled
                                            v-model="loan.negociationPeriod"
                                            v-else-if="
                                                loan.loanEarlyRedemptionNegociation &&
                                                loan.negociationType &&
                                                loan.negociationType === 'DURATION'
                                            "
                                            label="&#xc9;chéances restantes"
                                            density="compact"
                                            hide-details
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="d-flex align-center col-auto pr-3 title">
                                {{ $t("emprunts.informations-rachat") }}
                            </v-col>
                            <v-col class="d-flex align-center">
                                <v-divider />
                            </v-col>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="4" class="mt-2 pt-0">
                                        <v-switch
                                            v-model="loan.loanEarlyRedemption"
                                            label="Remboursement anticipé"
                                            hide-details
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-select-filled
                                            v-model="loan.redemptionType"
                                            v-if="loan.loanEarlyRedemption"
                                            :items="redemptionTypes"
                                            label="Type remboursement"
                                            item-value="value"
                                            hide-details
                                            density="compact"
                                            :item-title="(item) => item.text"
                                        />
                                    </v-col>
                                    <v-col cols="4" class="pl-1">
                                        <v-select-filled
                                            v-model="loan.loanEarlyRedemptionDate"
                                            v-if="loan.loanEarlyRedemption"
                                            :items="loanEarlyRedemptionDates"
                                            label="Date de remboursement"
                                            item-value="value"
                                            hide-details
                                            density="compact"
                                            :item-title="(item) => item.text"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="mt-2">
                                    <v-col cols="4" v-if="loan.loanEarlyRedemption">
                                        <oss-text-field-filled
                                            v-if="loan.loanEarlyRedemption"
                                            label="Montant remboursement"
                                            density="compact"
                                            hide-details
                                            v-model="loan.earlyRedemptionAmount"
                                        >
                                        </oss-text-field-filled>
                                    </v-col>
                                    <v-col v-if="loan.loanEarlyRedemption" cols="4">
                                        <oss-text-field-filled
                                            v-if="loan.loanEarlyRedemption"
                                            label="Montant IRA"
                                            density="compact"
                                            hide-details
                                            v-model="loan.iraRedemptionAmount"
                                            @update:modelValue="
                                                onInputChanged($event, 'iraRedemptionAmount')
                                            "
                                        >
                                        </oss-text-field-filled>
                                    </v-col>
                                    <v-col v-if="isPartialRedemption" cols="4" class="pl-1">
                                        <oss-text-field-filled
                                            label="Montant intérêts"
                                            density="compact"
                                            hide-details
                                            v-model="loan.earlyRedemptionInterest"
                                            @update:modelValue="
                                                onInputChanged($event, 'earlyRedemptionInterest')
                                            "
                                        >
                                        </oss-text-field-filled>
                                    </v-col>
                                    <v-col v-if="isPartialRedemption" cols="4">
                                        <oss-text-field-filled
                                            label="Montant assurances"
                                            density="compact"
                                            hide-details
                                            v-model="loan.earlyRedemptionInsurance"
                                            @update:modelValue="
                                                onInputChanged($event, 'earlyRedemptionInsurance')
                                            "
                                        >
                                        </oss-text-field-filled>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-2" v-if="loan.loanEarlyRedemption">
                                    <v-col cols="6">
                                        <AccountableAccount
                                            v-show="true"
                                            :showLabel="true"
                                            :label="`Compte d'IRA`"
                                            :inputStyle="'padding:0px; margin:0px;'"
                                            :showValidation="false"
                                            :companyId="companyId"
                                            :showDescription="true"
                                            :inAccountableAccountType="'Selected'"
                                            :inAccountableAccountNames="['627']"
                                            :inAccountableAccount="accountableAccountIRA"
                                            :disabled="false"
                                            :hideDetails="true"
                                            @select-accountableAccount="selectAccountableAccountIRA"
                                            :defineThirdParty="false"
                                            dense
                                        >
                                        </AccountableAccount>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="mt-1">
                            <v-col cols="12" class="d-flex justify-center">
                                <v-btn-prev :disabled="previousDisabled()" @click="previous()" />
                                <v-btn-next :disabled="nextDisabled()" @click="next()" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">{{ $t("emprunts.supr-doc") }}</h4>
        </oss-dialog>
        <oss-dialog
            v-model="restoreDialog"
            title="Restaurer le document"
            @valid="
                restoreDocument();
                restoreDialog = false;
            "
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="restoreLoading"
            width="800px"
        >
            <h4 class="text-center">{{ $t("emprunts.rest-doc") }}</h4>
        </oss-dialog>
        <oss-dialog
            v-if="document.id"
            v-model="uploadDocumentDialog"
            :title="$t('emprunts.import-doc')"
            max-width="60vw"
            :actions="actions"
        >
            <UploadDocument
                :showFirstPrevious="false"
                :companyId="companyId"
                :documentId="document?.id"
                :documentType="'MISCELLANEOUS'"
                :multiple="false"
                :actions="actions"
                :freeTag="false"
                :showBtns="true"
                @fileUploaded="
                    closeUploadDocumentDialog();
                    startToBeDoneIfNecessary();
                "
            />
        </oss-dialog>
        <oss-dialog
            v-model="thirdPartyCompanyDialog"
            :title="$t('emprunts.choisir-fournisseur')"
            max-width="60vw"
        >
            <CompaniesTable
                v-model="loan.thirdPartyCompany"
                :parentCompanyId="companyId"
                :showGenericCompany="false"
                :showConsumerCompany="false"
                :showCustomerCompanies="false"
                :showSupplierCompanies="true"
                :showExistingCompanies="true"
                :showNewCompanies="true"
                @select-company="selectThirdPartyCompany"
            />
        </oss-dialog>
        <oss-dialog v-model="bankDialog" :title="$t('emprunts.choisir-banque')" max-width="60vw">
            <BankAccountSelector
                v-model="loan.bankAccount"
                :companyId="companyId"
                @select-bank="selectBankAccount"
            />
        </oss-dialog>
        <oss-dialog
            v-model="analyseDocumentDialog"
            title="Relancer l'analyse du document"
            @valid="analyseDocument"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir relancer l'analyse ?</h4>
        </oss-dialog>
    </div>
</template>
<script lang="ts">
import {
    calculateLoan,
    PaymentPeriodicity,
    LoanDetailsDTO,
    ModifiableLoan,
    PaymentDetails,
    recalcAllManualPayments,
} from "../../../../backend/src/common/loan/loanServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { DocumentValidationBase } from "./DocumentValidationBase";
import ossPdf from "./DocumentPDF.vue";
import { DocumentMenu } from "./DocumentMenu.vue";
import DocumentWizardDialog from "./DocumentWizardDialog.vue";
import Chat from "../chat/Chat.vue";
import FreeTag from "../tag/FreeTag.vue";
import Sepa from "../pay/Sepa.vue";
import AccountingItemStatic from "../AccountingItemStatic.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import UPSERT_RECURRENT_DOCUMENT from "../../graphql/recurrentDocument/RecurrentDocuments.gql";
import _ from "lodash";
import AccountableAccount from "../AccountableAccount.vue";
import BankAccountSelector from "../bank/BankAccountSelector.vue";
import UploadDocument from "./UploadDocuments.vue";
import CompaniesTable from "../admin/CompaniesTable.vue";
import DocumentLoanOCR from "./DocumentLoanOCR.vue";
import moment from "moment-timezone";
import getEnv from "../../env";
import { Component, Vue, toNative, Ref } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { DialogAction } from "@/services/dialogAction";
import { LoanDeadLine } from "@/services/loan/loanDeadLine";
import { isInsideAccountingClosing } from "../../services/accountingPeriods";
import { getDBFormattedDate } from "../../services/dateServices";
import { mathFix } from "../../services/mathServices";

import {
    MenuDisplayDisplayModeOptions,
    MenuDisplayDotMenuOptions,
    MenuDisplayOptions,
    MenuDisplayZoomOptions,
    MenuDisplayRotationOptions,
} from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

const env = getEnv();

@Component({
    components: {
        DocumentWizardDialog,
        Chat,
        ossPdf,
        FreeTag,
        Sepa,
        AccountingItemStatic,
        UsersActivitiesHistory,
        AccountableAccount,
        BankAccountSelector,
        UploadDocument,
        CompaniesTable,
        DocumentMenu,
        DocumentLoanOCR,
    },
    emits: ["loan-upserted", "onEdit"],
})
export class DocumentLoan extends DocumentValidationBase {
    @Ref("ossPdfRef") ossPdf: any;

    items = [];

    editMode = false;
    editableItems = [];
    documentTags = [];

    loading = false;
    activeUploadDocument = false;
    showAccountingLines: boolean = false;
    restoreDialog = false;
    bankAccountDialog = false;
    uploadDocumentDialog = false;
    thirdPartyCompanyDialog = false;
    bankDialog = false;
    formValid = false;
    windowStep = "table";
    localEnv = env.environnement;
    accountableAccountMonthly = null;
    accountableAccountInterest = null;
    accountableAccountInsurance = null;
    accountableAccountBank = null;
    accountableAccountIRA = null;

    get periodicities(): { title: string; value: PaymentPeriodicity }[] {
        return [
            {
                title: this.$t("emprunts.monthly"),
                value: PaymentPeriodicity.MONTHLY,
            },
            {
                title: this.$t("emprunts.bimonthly"),
                value: PaymentPeriodicity.BIMONTHLY,
            },
            {
                title: this.$t("emprunts.trimester"),
                value: PaymentPeriodicity.TRIMONTHLY,
            },
            {
                title: this.$t("emprunts.semester"),
                value: PaymentPeriodicity.SEMIANNUAL,
            },
            {
                title: this.$t("emprunts.yearly"),
                value: PaymentPeriodicity.ANNUAL,
            },
        ];
    }

    newCommonFormatCurrency(value: number, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    defaultLoan: LoanDetailsDTO = {
        title: "",
        startDate: null,
        signatureDate: null,
        type: "LOAN",
        invoiceNumber: "",
        status: "ANALYSED",
        bobbeeStartDate: null,
        amortisationType: "",
        loanPeriod: null,
        netAmount: null,
        grossAmount: null,
        loanRate: null,
        insuranceType: "PERCENTAGE",
        insuranceRate: null,
        insuranceAmount: null,
        monthlyLoanRate: null,
        aaMonthlyName: "",
        aaInterestName: "",
        aaInsuranceName: "",
        aaBankName: "",
        aaIraName: "",
        iraType: {
            value: "",
            text: "",
        },
        redemptionType: "",
        iraRedemptionAmount: null,
        loanEarlyRedemption: false,
        earlyRedemptionAmount: null,
        earlyRedemptionInterest: null,
        earlyRedemptionInsurance: null,
        negociationRate: null,
        negociationPeriod: null,
        negociationDate: "",
        loanEarlyRedemptionNegociation: false,
        negociationType: "",
        loanEarlyRedemptionDate: "",
        thirdPartyCompany: {
            id: "",
            name: "",
        },
        bankAccount: {
            id: "",
            name: "",
        },
        // bankAccountId: "",
        organisationType: {
            value: "BANK",
            text: "Banque",
        },
        tags: [],
    };

    loan = _.cloneDeep(this.defaultLoan);

    deadlines: LoanDeadLine[];

    documentType_ = "";

    actions = {
        action: new DialogAction(),
    };

    get documentMenuZoomOptions(): MenuDisplayZoomOptions {
        const zoomOptions: MenuDisplayZoomOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.zoomButtons,
        };

        zoomOptions.isDisplay =
            (!this.isPDF && this.zoomManager && this.windowStep === "display-pdf") ||
            (this.isPDF && this.windowStep === "display-pdf");
        zoomOptions.isResetZoomDisabled = this.isPDF ? false : this.zoomManager.disableResetZoom();
        zoomOptions.isZoomInDisabled = this.isPDF ? false : this.zoomManager.disableZoomIn();
        zoomOptions.isZoomOutDisabled = this.isPDF ? false : this.zoomManager.disableZoomOut();

        return zoomOptions;
    }

    get documentMenuDisplayModeOptions(): MenuDisplayDisplayModeOptions {
        const displayModeOptions: MenuDisplayDisplayModeOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.displayModeButtons,
        };

        displayModeOptions.isDisplay = true;
        displayModeOptions.isTableModeDisplay = true;
        displayModeOptions.isAccountingLineModeDisplay = this.document.accountingLines?.length;
        displayModeOptions.isPDFModeDisplay = true;
        displayModeOptions.isPDFModeDisabled = !this.document.signedUrl;

        console.log("document.accountingLines", this.document.accountingLines);

        return displayModeOptions;
    }

    get documentMenuOptionsRotateDocumentButton(): MenuDisplayRotationOptions {
        const rotationButton: MenuDisplayRotationOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.RotateDocument,
        };

        rotationButton.isDisplay =
            (!this.isPDF && this.windowStep === "display-pdf") ||
            (this.isPDF && this.windowStep === "display-pdf");

        return rotationButton;
    }

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenuOptions: MenuDisplayDotMenuOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
        };

        dotMenuOptions.isDisplay = true;

        dotMenuOptions.download.isDisplay = !!this.document.signedUrl;
        dotMenuOptions.download.title = "Télécharger le document";

        dotMenuOptions.upload.isDisplay = !this.document.signedUrl;
        dotMenuOptions.upload.title = "Ajouter un document";

        dotMenuOptions.activity.isDisplay = this.isAccountingUser;
        dotMenuOptions.activity.title = "Afficher l'activité";

        dotMenuOptions.delete.isDisplay = true;
        dotMenuOptions.delete.title = "Supprimer";
        dotMenuOptions.delete.disabled = this.disabledDelete;

        return dotMenuOptions;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = {
            ...documentMenuDisplayOptionsDefaultScheme,
        };

        documentMenuOption.zoomButtons = this.documentMenuZoomOptions;
        documentMenuOption.RotateDocument = this.documentMenuOptionsRotateDocumentButton;
        documentMenuOption.displayModeButtons = this.documentMenuDisplayModeOptions;
        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions;

        return documentMenuOption;
    }

    /**
     * Zooms in the PDF by increasing its zoom level.
     */
    public zoomInPdf(): void {
        if (this.ossPdf) {
            this.ossPdf.zoomIn();
        }
    }

    /**
     * Resets the zoom level of the PDF to its default state.
     */
    public resetZoomPdf(): void {
        if (this.ossPdf) {
            this.ossPdf.resetZoom();
        }
    }

    /**
     * Zooms out the PDF by decreasing its zoom level.
     */
    public zoomOutPdf(): void {
        if (this.ossPdf) {
            this.ossPdf.zoomOut();
        }
    }

    get toEditDeadline() {
        return LoanDeadLine.toEdit;
    }

    get isPartialRedemption() {
        return this.loan?.loanEarlyRedemption && this.loan?.redemptionType === "PARTIAL";
    }

    set toEditDeadline(value: LoanDeadLine) {
        LoanDeadLine.selected = value;
        // LoanDeadLine.toEdit = value;
    }

    get isValid() {
        if (!this.formValid) return false;
        if (this.loan.organisationType?.value === "BANK") {
            if (!this.loan.bankAccount?.id) {
                return false;
            }
        } else if (this.loan.organisationType?.value === "THIRDPARTY") {
            if (!this.loan.thirdPartyCompany?.id) {
                return false;
            }
        }
        return true;
    }

    get isInsideAccountingClosing() {
        if (this.loan && typeof this.loan === "object") {
            if (this.loan?.bobbeeStartDate) {
                return isInsideAccountingClosing(this.$store, this.loan.bobbeeStartDate);
            }
        }

        return false;
    }

    created() {
        this.syncEditedLoan();
    }

    @Watch("calculatedMonthlyLoan", { immediate: true, deep: true })
    syncEditedLoan() {
        // Create a deep copy and store both raw & formatted values
        this.editedLoan = this.calculatedMonthlyLoan.map((item) => ({
            ...item,
            formattedValues: {
                dueAmountStartPeriod: newCommonFormatCurrency(item.dueAmountStartPeriod, undefined),
                monthlyPayment: newCommonFormatCurrency(item.monthlyPayment, undefined),
                monthlyInterest: newCommonFormatCurrency(item.monthlyInterest, undefined),
                amortisation: newCommonFormatCurrency(item.amortisation, undefined),
                monthlyInsurance: newCommonFormatCurrency(item.monthlyInsurance, undefined),
                dueAmountEndPeriod: newCommonFormatCurrency(item.dueAmountEndPeriod, undefined),
                iraRedemptionAmount: item.iraRedemptionAmount
                    ? newCommonFormatCurrency(item.iraRedemptionAmount, undefined)
                    : "",
            },
            modifiedFields: [],
        }));
    }

    beforeMount() {
        if (this.inDocument && this.inDocument.id) {
            this.svgSuffix = "document-loan";
            //
            this.onDocumentChanged(this.inDocument?.id, undefined);
            if (!this.document.displayName) {
                this.document.displayName = this.document.name;
            }
            this.finishMounted();
        }
        this.initialize();
        this.calculateMonthlyLoanRate();

        const accountableAccountInterest =
            this.$store.state.accountableAccountTable.accountableAccounts.find((aa) =>
                aa.name?.startsWith("661100"),
            );
        const accountableAccountInsurance =
            this.$store.state.accountableAccountTable.accountableAccounts.find((aa) =>
                aa.name?.startsWith("616100"),
            );
        const accountableAccountBank =
            this.$store.state.accountableAccountTable.accountableAccounts.find((aa) =>
                aa.name?.startsWith("478100"),
            );
        const accountableAccountIRA =
            this.$store.state.accountableAccountTable.accountableAccounts.find((aa) =>
                aa.name?.startsWith("627100"),
            );
        let dataAAInterest = null;
        let dataAAInsurance = null;
        let dataAABank = null;
        let dataAAIRA = null;

        if (accountableAccountInterest) {
            dataAAInterest = {
                accountableAccount: accountableAccountInterest,
            };
            if (dataAAInterest && dataAAInterest.accountableAccount) {
                this.selectAccountableAccountInterest(dataAAInterest);
            }
        }
        if (accountableAccountInsurance) {
            dataAAInsurance = {
                accountableAccount: accountableAccountInsurance,
            };
            if (dataAAInsurance && dataAAInsurance.accountableAccount) {
                this.selectAccountableAccountInsurance(dataAAInsurance);
            }
        }
        if (accountableAccountBank) {
            dataAABank = {
                accountableAccount: accountableAccountBank,
            };
            if (dataAABank && dataAABank.accountableAccount) {
                this.selectAccountableAccountBank(dataAABank);
            }
        }
        if (accountableAccountIRA) {
            dataAAIRA = {
                accountableAccount: accountableAccountIRA,
            };
            if (dataAAIRA && dataAAIRA.accountableAccount) {
                this.selectAccountableAccountIRA(dataAAIRA);
            }
        }

        this.onAnalysisChanged();
    }

    @Watch("analysis")
    onAnalysisChanged() {
        const dataDeadlines =
            this.document.data?.amortizationTable?.deadlines || this.analysis?.deadlines;
        if (dataDeadlines) {
            const deadlines = [];
            let index = 0;
            for (const dataDeadline of dataDeadlines) {
                const deadline: LoanDeadLine = Object.assign(
                    new LoanDeadLine(),
                    dataDeadline,
                    {},
                ) as LoanDeadLine;
                deadlines.push(deadline);
                deadline.index = index;
                if (deadline.focus === undefined) {
                    deadline.focus = false;
                }
                if (deadline.selected === undefined) {
                    deadline.selected = true;
                }
                index++;
            }
            this.deadlines = deadlines;
        } else {
            this.deadlines = [];
        }
        // debugger;
        // if (inputData.totalDebit !== undefined) {
        //     this.totalDebit = inputData.totalDebit;
        // }
        // if (inputData.totalCredit !== undefined) {
        //     this.totalCredit = inputData.totalCredit;
        // }
        // if (inputData.startBalance !== undefined) {
        //     this.startBalance = inputData.startBalance;
        // }
        // if (inputData.endBalance !== undefined) {
        //     this.endBalance = inputData.endBalance;
        // }
        // if (this?.inDocument?.data?.onlyBalances) {
        //     this.onlyBalances = this.inDocument.data.onlyBalances;
        // } else this.onlyBalances = false;
        // if (this?.inDocument?.data?.removeDuplicates) {
        //     this.removeDuplicates = this.inDocument.data.removeDuplicates;
        // } else this.removeDuplicates = false;
    }

    @Watch("document", { deep: true })
    initialize() {
        if (this.document) {
            if (this.document?.data?.recurrentDocument) {
                this.loan = JSON.parse(JSON.stringify(this.document.data.recurrentDocument));
            } else {
                this.loan = _.cloneDeep(this.defaultLoan);
            }
        } else {
            this.loan = _.cloneDeep(this.defaultLoan);
        }
    }

    get documentType() {
        if (this.documentType_) {
            return this.documentType_;
        }
        return this.document.type;
    }

    set documentType(data) {
        this.documentType_ = data;
    }

    get reUploadDocument() {
        if (!this.document) return false;
        if (this.currentUser.profile.configuration.document.write) {
            return true;
        }
        return false;
    }

    get headers() {
        const headers = [
            { title: this.$t("emprunts.date"), value: "month" },
            { title: this.$t("emprunts.capital-debut-periode"), value: "dueAmountStartPeriod" },
            { title: this.$t("emprunts.mensualite"), value: "monthlyPayment" },
            { title: this.$t("emprunts.amortissement"), value: "amortisation" },
            { title: this.$t("emprunts.interets"), value: "monthlyInterest" },
            { title: this.$t("emprunts.assurances"), value: "monthlyInsurance" },
            { title: this.$t("emprunts.capital-restant-du"), value: "dueAmountEndPeriod" },
        ];

        if (this.loan.loanEarlyRedemption && this.loan.loanEarlyRedemptionDate) {
            headers.push({ title: this.$t("emprunts.montant-ira"), value: "iraRedemptionAmount" });
        }

        return headers;
    }

    get amortisationTypes() {
        const amortisationTypes: { text: string; value: string }[] = [
            { value: "CONSTANT", text: this.$t("emprunts.constante") },
            { value: "DEGRESSIVE", text: this.$t("emprunts.degressive") },
        ];
        return amortisationTypes;
    }

    get organisationTypes() {
        const amortisationTypes: { text: string; value: string }[] = [
            { value: "BANK", text: this.$t("emprunts.banque") },
            { value: "THIRDPARTY", text: this.$t("emprunts.fournisseur") },
        ];
        return amortisationTypes;
    }

    get insuranceTypes() {
        const insuranceTypes: { text: string; value: string }[] = [
            { value: "AMOUNT", text: this.$t("emprunts.montant") },
            { value: "PERCENTAGE", text: this.$t("emprunts.taux") },
        ];
        return insuranceTypes;
    }

    get iraTypes() {
        const iraTypes: { text: string; value: string }[] = [
            { value: "RATE", text: this.$t("emprunts.pourcentage") },
            { value: "AMOUNT", text: this.$t("emprunts.montant") },
        ];
        return iraTypes;
    }

    get redemptionTypes() {
        const redemptionTypes: { text: string; value: string }[] = [
            { value: "PARTIAL", text: this.$t("emprunts.rachat-partial") },
            { value: "FULL", text: this.$t("emprunts.rachat-total") },
        ];
        // const redemptionTypes = [
        //     { value: "PARTIAL", text: "Remboursement partiel" },
        //     { value: "FULL", text: "Remboursement total" },
        // ];
        return redemptionTypes;
    }

    get negociationTypes() {
        const negociationTypes: { text: string; value: string }[] = [
            { value: "RATE", text: this.$t("emprunts.renegotiation-taux") },
            { value: "DURATION", text: this.$t("emprunts.renegotiation-duree") },
        ];
        return negociationTypes;
    }

    toggleEditMode() {
        if (this.editMode) {
            this.discardChanges(); // Reset modifications when discarding
        }
        this.editMode = !this.editMode;
    }
    get loanEarlyRedemptionDates() {
        const loanEarlyRedemptionDates = [];

        if (this.calculatedMonthlyLoan) {
            this.calculatedMonthlyLoan.forEach((payment) => {
                loanEarlyRedemptionDates.push({
                    value: payment.month,
                    text: payment.month,
                });
            });
        }
        return loanEarlyRedemptionDates;
    }

    get negociationDates() {
        const negociationDates: { text: string; value: string }[] = [];

        if (this.calculatedMonthlyLoan) {
            this.calculatedMonthlyLoan.forEach((payment) => {
                negociationDates.push({
                    value: payment.month,
                    text: payment.month,
                });
            });
        }
        return negociationDates;
    }

    get monthlyAccountableAccounts() {
        const monthlyAccountableAccounts: string[] = ["164000"];

        return monthlyAccountableAccounts;
    }

    discardChanges() {
        // Restore original values
        this.syncEditedLoan(); // Simply refresh from the original source
    }
    originalData: ModifiableLoan[] = [];
    editedLoan: ModifiableLoan[] = [];
    get calculatedMonthlyLoan(): ModifiableLoan[] {
        if (
            !this.loan?.netAmount ||
            !this.loan?.loanRate ||
            !this.loan?.loanPeriod ||
            !this.loan?.monthlyLoanRate ||
            !this.loan?.insuranceType
        ) {
            return [];
        } else {
            let calculatedMonthlyLoan: ModifiableLoan[];

            try {
                calculatedMonthlyLoan = calculateLoan(this.loan);
            } catch (error) {
                console.error(error);
            }

            if (calculatedMonthlyLoan) {
                calculatedMonthlyLoan.forEach((payment) => {
                    payment.dueAmountStartPeriod = mathFix(payment.dueAmountStartPeriod, 2);
                    payment.monthlyPayment = mathFix(payment.monthlyPayment, 2);
                    payment.monthlyInterest = mathFix(payment.monthlyInterest, 2);
                    payment.monthlyInsurance = mathFix(payment.monthlyInsurance, 2);
                    payment.amortisation = mathFix(payment.amortisation, 2);
                    payment.dueAmountEndPeriod = mathFix(payment.dueAmountEndPeriod, 2);
                });
            }

            return calculatedMonthlyLoan || [];
        }
    }

    @Watch("loan.loanRate")
    calculateMonthlyLoanRate() {
        if (this.loan?.loanRate) {
            this.loan.monthlyLoanRate = (this.loan.loanRate * 100) / 12 / 100;
            this.loan.monthlyLoanRate = mathFix(this.loan.monthlyLoanRate, 2);
        }
    }

    @Watch("loan.loanEarlyRedemptionDate")
    updateLoanEarlyRedemptionAmount() {
        if (
            this.loan.loanEarlyRedemptionDate &&
            this.loan.redemptionType === "FULL" &&
            this.calculatedMonthlyLoan
        ) {
            const selectedPayment = this.calculatedMonthlyLoan.find(
                (payment) => payment.month === this.loan.loanEarlyRedemptionDate,
            );
            if (selectedPayment) {
                this.loan.earlyRedemptionAmount =
                    Math.round(selectedPayment.dueAmountStartPeriod * 100) / 100;
            }
        }
    }

    selectAccountableAccountMonthly(data: { accountableAccount: any }) {
        this.accountableAccountMonthly = data.accountableAccount;

        if (this.accountableAccountMonthly && this.accountableAccountMonthly.name) {
            this.loan.aaMonthlyName = this.accountableAccountMonthly.name;
        }
    }

    selectAccountableAccountInterest(data: { accountableAccount: any }) {
        this.accountableAccountInterest = data.accountableAccount;

        if (this.accountableAccountInterest && this.accountableAccountInterest.name) {
            this.loan.aaInterestName = this.accountableAccountInterest.name;
        }
    }

    selectAccountableAccountInsurance(data: { accountableAccount: any }) {
        this.accountableAccountInsurance = data.accountableAccount;

        if (this.accountableAccountInsurance && this.accountableAccountInsurance.name) {
            this.loan.aaInsuranceName = this.accountableAccountInsurance.name;
        }
    }

    selectAccountableAccountBank(data: { accountableAccount: any }) {
        this.accountableAccountBank = data.accountableAccount;

        if (this.accountableAccountBank && this.accountableAccountBank.name) {
            this.loan.aaBankName = this.accountableAccountBank.name;
        }
    }

    selectAccountableAccountIRA(data: { accountableAccount: any }) {
        this.accountableAccountIRA = data.accountableAccount;

        if (this.accountableAccountIRA && this.accountableAccountIRA.name) {
            this.loan.aaIraName = this.accountableAccountIRA.name;
        }
    }

    async valid() {
        await this.upsertLoan();
    }

    async upsertLoan() {
        if (this.loan.netAmount) {
            this.loan.grossAmount = this.loan.netAmount;
        }

        // ✅ Ensure `editedLoan` is properly updated
        const updatedPaymentDetails = this.editedLoan.map((item) => {
            const updatedFields = item.modifiedFields || [];

            // ✅ Create a copy of item and update only modified fields
            const updatedItem: Partial<PaymentDetails> = { ...item };

            updatedFields.forEach((field) => {
                (updatedItem[field as keyof PaymentDetails] as number) = item[field] as number;
            });

            return updatedItem;
        });

        if (this.loan.bobbeeStartDate) {
            this.loan.bobbeeStartDate = getDBFormattedDate(this.loan.bobbeeStartDate);
        }

        if (this.loan.startDate) {
            this.loan.startDate = getDBFormattedDate(this.loan.startDate);
        }
        this.loan.paymentDetails = updatedPaymentDetails;
        const upsertedLoan = await this.$apollo.mutate({
            mutation: UPSERT_RECURRENT_DOCUMENT,
            variables: {
                id: this.document?.id || "",
                companyId: this.companyId,
                recurrentDocument: this.loan,
            },
        });

        if (upsertedLoan.data.upsertRecurrentDocument) {
            this.$emit("loan-upserted", upsertedLoan.data.upsertRecurrentDocument);
            this.$router.go(-1);
        }
        //Do we have some sort of system to tell the user something went wrong?
        //Else , just leave the user waiting
    }

    calculateLoan(loan: LoanDetailsDTO) {
        try {
            const calculatedLoan = calculateLoan(loan);
            return calculatedLoan;
        } catch (error) {
            console.error(error);
        }
    }

    @Watch("documentId")
    async onDocumentChanged(prev, next) {
        if (prev !== next) {
            this.onDocumentChangedCommon(prev, next);

            if (!this.document?.signedUrl && this.isAccountingUser) {
                this.showAccountingLines = true;
            }
        }
        this.finishMounted();
    }

    closeUploadDocumentDialog() {
        this.uploadDocumentDialog = false;
        this.$emit("onEdit");
    }

    selectThirdPartyCompany(data: { id: any; name: string }) {
        if (data && data?.id) {
            this.loan.thirdPartyCompany = data;
        } else {
            this.loan.thirdPartyCompany = null;
        }

        this.thirdPartyCompanyDialog = false;
    }

    selectBankAccount(data: any) {
        // if (data && data.id) {
        //     this.loan.bankAccount = data;
        // } else {
        //     this.loan.bankAccount = null;
        // }

        this.bankDialog = false;
    }

    @Watch("loan.loanEarlyRedemption")
    updateLoanEarlyRedemption() {
        if (!this.loan.loanEarlyRedemption) {
            this.loan.earlyRedemptionAmount = null;
            this.loan.earlyRedemptionInterest = null;
            this.loan.earlyRedemptionInsurance = null;
            this.loan.iraRedemptionAmount = null;
            this.loan.loanEarlyRedemptionDate = null;
            this.calculateLoan(this.loan);
        }
    }

    @Watch("loan.negociationType")
    updateNegociationPeriod() {
        if (this.loan.negociationType === "RATE") {
            this.loan.negociationPeriod = null;
        } else if (this.loan.negociationType === "DURATION") {
            this.loan.negociationRate = null;
        }
    }

    @Watch("loan.loanEarlyRedemptionNegociation")
    updateNegociation() {
        if (!this.loan.loanEarlyRedemptionNegociation) {
            this.loan.negociationRate = null;
            this.loan.negociationPeriod = null;
            this.loan.negociationDate = null;
            this.loan.negociationType = "";
        }
    }

    @Watch("loan.negociationDate")
    @Watch("loan.negociationType")
    updateNegociationPeriodDuration() {
        // If "DURATION" and negociationDate are selected, then negociationPeriod is the length of payments in the payments list after negociationDate
        if (this.loan.negociationDate && this.loan.negociationType === "DURATION") {
            const remainingNegociationPeriod = this.calculatedMonthlyLoan.filter((payment) =>
                moment(payment.month, "DD/MM/YYYY").isSameOrAfter(this.loan.negociationDate),
            ).length;
            this.loan.negociationPeriod = remainingNegociationPeriod;
        } else {
            this.loan.negociationPeriod = null;
        }
    }

    /**
     * Méthode pour gérer les entrées utilisateurs.
     * Remplace les virgules par des points dans les champs concernés.
     * TODO: à déplacer dans un service de formatage de données que prend en compte la localisation
     */
    onInputChanged(value: string, field: string) {
        // Remplace la virgule par un point
        if (typeof value === "string") {
            this.loan[field] = value.replace(",", ".");
        }
    }

    @Watch("document.tags", { deep: true })
    onDocumentLoaded() {
        if (this.document?.tags?.length) {
            const existingTagIds = new Set(this.loan.tags.map((tag) => tag.id));

            this.document.tags.forEach((tag) => {
                if (!existingTagIds.has(tag.id)) {
                    this.loan.tags.push(tag);
                    existingTagIds.add(tag.id);
                }
            });
        }
    }

    upsertDocumentTags(tags) {
        if (tags.tags.length) {
            const existingTagIds = new Set(this.loan.tags.map((tag) => tag.id));

            tags.tags.forEach((tag) => {
                if (!existingTagIds.has(tag.id)) {
                    this.loan.tags.push(tag);
                    existingTagIds.add(tag.id);
                }
            });
        }
    }

    @Watch("loan.insuranceType", { deep: true })
    onInsuranceTypesChanged() {
        if (this.loan.insuranceType === "AMOUNT") {
            this.loan.insuranceRate = null;
        } else {
            this.loan.insuranceAmount = null;
        }
    }

    markAsModified(item, field: string) {
        if (!item.modifiedFields) {
            item.modifiedFields = [];
        }
        if (!item.modifiedFields.includes(field)) {
            item.modifiedFields.push(field);
        }
    }

    /**
     * Handles input change while keeping raw numeric values
     */
    handleInput(item: ModifiableLoan, field: keyof PaymentDetails, event: Event) {
        const target = event.target as HTMLInputElement;
        let rawValue = target.value;

        // 1) Clean/parse the input
        rawValue = rawValue.replace(/[^0-9,.-]/g, "");
        rawValue = rawValue.replace(/,/g, ".");
        const numericValue = Number(rawValue);
        // 2) Store the user’s new numeric value on the item
        if (!isNaN(numericValue)) {
            (item[field] as number) = numericValue;
            item.formattedValues[field] = rawValue;
            this.markAsModified(item, field);
        }
    }

    /**
     * Formats the value after editing
     */
    onBlurAction(item: ModifiableLoan, field: keyof PaymentDetails) {
        const index = this.editedLoan.findIndex((p) => p === item);
        item.formattedValues[field] = newCommonFormatCurrency(item[field], undefined);
        if (item.modifiedFields.includes(field))
            recalcAllManualPayments(this.editedLoan, this.loan, index);

        //Check if last payment has amountDueAfterperiod != 0
        const remainder = this.editedLoan[this.editedLoan.length - 1].dueAmountEndPeriod;
    }

    loanTotals() {
        return this.editedLoan.reduce(
            (totals, payment) => {
                totals.totalMonthlyPayments += payment.monthlyPayment;
                totals.totalAmortisation += payment.amortisation;
                totals.totalInterest += payment.monthlyInterest;
                totals.totalInsurance += payment.monthlyInsurance;
                return totals;
            },
            {
                totalMonthlyPayments: 0,
                totalAmortisation: 0,
                totalInterest: 0,
                totalInsurance: 0,
            },
        );
    }
}

export default toNative(DocumentLoan);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
.bad-format {
    background-color: red;
    color: white;
}
/* Default style when editMode is false - Fields look like plain text */
.v-input .hide-input input {
    border: none;
    background-color: white;
    cursor: pointer;
    pointer-events: none;
}

/* When editMode is true - Fields become visible */
.editable-field {
    border: 1px solid #ccc;
    background-color: #f9f9f9;
    cursor: text;
    pointer-events: all;
}

/* When a field is modified, change the background to blue */
.modified input {
    background-color: var(--oss_light_blue);
}
::v-deep(.hide-input input) {
    font-size: 0.875rem;
}
::v-deep(.editable-field input) {
    font-size: 0.875rem;
}
.totals-row {
    background-color: #f8f9fa; /* Light gray background */
    font-weight: bold;
    padding-inline: var(--v-field-padding-start) var(--v-field-padding-end);
    padding-top: var(--v-field-input-padding-top);
    padding-bottom: var(--v-field-input-padding-bottom);
}
.edit-emprunt {
    width: 29px;
    height: 29px;
    padding: 6px;
}
</style>
